module.exports = __webpack_public_path__ + "img/prj08.53160b41.png";